import { Link } from "react-router-dom";
import logo from './logo.png'
const Logo = ({ color = true }) => {

  return (
    <div
      style={{
        position: 'relative',
        top:"10px"
    }}
    >
      <div className="items-center logoShadow hover:scale-110 hover:text-green-600 transition-all duration-400 ease-in-out">
        <Link
          to="/"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-0"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems :'center'
          }}
        >
          <img
            src={logo}
            alt="BusinessXstream"
            className="h-12 cursor-pointer"
            style={{
              position: 'relative',
              top: "-10px",
              height :"50px"
            }}
          
          />
          <div>

          <p className="navbar-font flex text-gray-200 font-bold tracking-wide">
            <span
              className={color ? "text-blue-900" : "text-blue-900"}

            >B</span>
            <span className={color ? "text-[white]" : "text-gray-800"}>
              usiness
            </span>
            <span
              className={color ? "text-red-500" : "text-red-500"}
            // className="text-red-500"
            >X</span>
            <span
              className={color ? "text-[white]" : "text-gray-800"}
            // className="text-gray-800"

            >Stream.com</span>
            </p>
          </div>


        </Link>

        {/* <div className="hidden sm:flex gap-4 ml-6 justify-center w-full">
                    <span
                        className={color ? "bg-[orange] text-transparent bg-clip-text text-xl sm:text-lg" : "bg-black text-transparent bg-clip-text text-xl sm:text-lg"}
                        
                        
                    
                    >
                        Innovate
                    </span>
                    <span
                        className={color ? "bg-[red] text-transparent bg-clip-text text-xl sm:text-lg" : "bg-black text-transparent bg-clip-text text-xl sm:text-lg"}
                    
                    >
                        Strategize
                    </span>
                    <span
                        className={color ? "bg-[orange] text-transparent bg-clip-text text-xl sm:text-lg" : "bg-black text-transparent bg-clip-text text-xl sm:text-lg"}
                    >
                        Achieve
                    </span>
                </div> */}
      </div>
    </div>
  );
};

export default Logo;
